export default "__VITE_ASSET__CyJoxOiE__"